import * as React from "react";
import { ConnectExistingCases } from "app/components/connect-existing-cases/connect-existing-cases";
import { Favourite } from "app/area/favourite/favourite";
import styles from "./bowtie-connect-case.scss";
import { withCallsToActions } from "app/area/case/features/calls-to-actions";
import { useConnectedCases } from 'app/area/bowtie/dropdown/bowtie-meatball-menu-hooks';
import { SEQUENCE_DIRECTION } from "app/area/case/features/connected-cases/sequence";
import { BowtieTooltipType } from "app/area/bowtie/types";

interface BowtieConnectCaseProps {
  caseData: any;
  addNewCase: () => void;
  caseConnectCaseType: string;
  translation: any;
  connectionTypeId?: number;
  onChangeCaseConnection?: (params: {
    caseId: number; connectionType: number; connectedCaseId: number; isBowtie: boolean;
    instanceKey: string;
  }) => void;
  changeSequence: (direction: SEQUENCE_DIRECTION) => void;
  domainId?: number;
  type: BowtieTooltipType;
}
const BowtieConnectCaseContainer: React.FC<BowtieConnectCaseProps> = (
  props
) => {
  const { caseData, addNewCase, translation, connectionTypeId, onChangeCaseConnection, domainId, caseConnectCaseType,
    type
   } = props;
  const { instanceKey, validateCaseId, connectedCasesByConnectionType, updateBowtieInstance, loadConnectedCasesByConnectionType } = 
  useConnectedCases(caseData?.caseNumber, [connectionTypeId]);

  const changeCaseConnection = async (params) => {
    const response = await onChangeCaseConnection({
      ...params,
      isBowtie: true,
      instanceKey
    });
    loadConnectedCasesByConnectionType(caseData?.caseNumber, [connectionTypeId], instanceKey);
    updateBowtieInstance(instanceKey, caseData.caseNumber, [connectionTypeId]);
    return response;
  };
  return (
    <div className={`${styles.bowtieDropdownContent} bowtie-connect-case-container`}>
      <ul>
        {type === BowtieTooltipType.meatBallCaseConnectDropdown ? (
          <li>
            <button onClick={addNewCase} className="dropdown-item">
              {translation.textAddNewDecayMechanism}
            </button>
          </li>
        ) : null}
        {type === BowtieTooltipType.caseConnectDropdown ? (
          <li>
            <button onClick={addNewCase} className="dropdown-item">
              {translation.textAddNewCase}
            </button>
          </li>
        ) : null}
        <ConnectExistingCases
          {...translation}
          caseId={caseData.caseNumber}
          subordinateId={connectionTypeId}
          label={type === BowtieTooltipType.meatBallCaseConnectDropdown ? 
            translation.textConnectDecayMechanism : translation.textConnectExisting}
          connectedCasesIdsByConnectionType={connectedCasesByConnectionType}
          allowWarnings={false}
          searchEnabled
          favouriteComponent={Favourite}
          onChangeCaseConnection={changeCaseConnection}
          onCloseCallback={() =>
            updateBowtieInstance(instanceKey, caseData.caseNumber, [
              connectionTypeId
            ])
          }
          disconnectWarning
          validateCaseId={(caseIdToConnect) =>
            validateCaseId(instanceKey, caseIdToConnect)
          }
          domainId={domainId}
          caseConnectCaseType={caseConnectCaseType}
        />
      </ul>
    </div>
  );
};
export const BowtieConnectCase = withCallsToActions(BowtieConnectCaseContainer);
